/**
 * @generated SignedSource<<e3b0c54bc6405f8251789de2d250be25>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type OrganizationMembershipContentUsagesOrderBy = "name" | "%future added value";
export type AdminMembersReportContentUsagesTableQuery$variables = {
  after?: string | null;
  before?: string | null;
  contentLabelIds?: ReadonlyArray<string> | null;
  direction?: OrderDirection | null;
  excludeProductLevel?: boolean | null;
  first?: number | null;
  id: string;
  last?: number | null;
  memberHasViewed?: boolean | null;
  orderBy?: OrganizationMembershipContentUsagesOrderBy | null;
  productIds?: ReadonlyArray<string> | null;
};
export type AdminMembersReportContentUsagesTableQuery$data = {
  readonly node: {
    readonly id?: string;
    readonly " $fragmentSpreads": FragmentRefs<"AdminMembersReportContentUsagesTable_PaginationFragment">;
  } | null;
};
export type AdminMembersReportContentUsagesTableQuery = {
  response: AdminMembersReportContentUsagesTableQuery$data;
  variables: AdminMembersReportContentUsagesTableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentLabelIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "direction"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeProductLevel"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberHasViewed"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productIds"
},
v11 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v14 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v15 = {
  "kind": "Variable",
  "name": "contentLabelIds",
  "variableName": "contentLabelIds"
},
v16 = {
  "kind": "Variable",
  "name": "direction",
  "variableName": "direction"
},
v17 = {
  "kind": "Variable",
  "name": "excludeProductLevel",
  "variableName": "excludeProductLevel"
},
v18 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v19 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v20 = {
  "kind": "Variable",
  "name": "memberHasViewed",
  "variableName": "memberHasViewed"
},
v21 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v22 = {
  "kind": "Variable",
  "name": "productIds",
  "variableName": "productIds"
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v24 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportContentUsagesTableQuery",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v12/*: any*/),
              {
                "args": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "memberOrganizationMembershipId",
                    "variableName": "id"
                  },
                  (v21/*: any*/),
                  (v22/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "AdminMembersReportContentUsagesTable_PaginationFragment"
              }
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v10/*: any*/),
      (v4/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "AdminMembersReportContentUsagesTableQuery",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v23/*: any*/),
          (v12/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v24/*: any*/),
                "concreteType": "ContentUsageNodeConnection",
                "kind": "LinkedField",
                "name": "contentUsages",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentUsageNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsage",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "entity",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "type",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "contentLabelId",
                                "storageKey": null
                              },
                              (v12/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "product",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              (v12/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "module",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isCurriculumModule",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isCollectionModule",
                                "storageKey": null
                              },
                              (v25/*: any*/),
                              (v12/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "organizationMembershipId",
                                "variableName": "id"
                              }
                            ],
                            "concreteType": "ReportingContentView",
                            "kind": "LinkedField",
                            "name": "reportingContentView",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v23/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfoObjectType",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v24/*: any*/),
                "filters": [
                  "contentLabelIds",
                  "productIds",
                  "excludeProductLevel",
                  "memberHasViewed",
                  "orderBy",
                  "direction"
                ],
                "handle": "connection",
                "key": "AdminMembersReportContentUsagesTable_contentUsages",
                "kind": "LinkedHandle",
                "name": "contentUsages"
              }
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bd273cbbc216b4d2b3528315a18cb706",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportContentUsagesTableQuery",
    "operationKind": "query",
    "text": "query AdminMembersReportContentUsagesTableQuery(\n  $id: ID!\n  $first: Int\n  $after: String\n  $last: Int\n  $before: String\n  $contentLabelIds: [ID!]\n  $productIds: [ID!]\n  $excludeProductLevel: Boolean\n  $memberHasViewed: Boolean\n  $orderBy: OrganizationMembershipContentUsagesOrderBy\n  $direction: OrderDirection\n) {\n  node(id: $id) {\n    __typename\n    ... on OrganizationMembership {\n      id\n      ...AdminMembersReportContentUsagesTable_PaginationFragment_3g0hOa\n    }\n    id\n  }\n}\n\nfragment AdminMembersReportContentUsagesTableRowFragment_4er94r on ContentUsage {\n  id\n  entity\n  content {\n    name\n    type\n    contentLabelId\n    id\n  }\n  product {\n    name\n    id\n  }\n  module {\n    isCurriculumModule\n    isCollectionModule\n    name\n    id\n  }\n  reportingContentView(organizationMembershipId: $id) {\n    id\n  }\n}\n\nfragment AdminMembersReportContentUsagesTable_PaginationFragment_3g0hOa on OrganizationMembership {\n  id\n  contentUsages(first: $first, after: $after, last: $last, before: $before, contentLabelIds: $contentLabelIds, productIds: $productIds, excludeProductLevel: $excludeProductLevel, memberHasViewed: $memberHasViewed, orderBy: $orderBy, direction: $direction) {\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        ...AdminMembersReportContentUsagesTableRowFragment_4er94r\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      startCursor\n      hasNextPage\n      hasPreviousPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "47307c11ab390f5039afe396549712d9";

export default node;
